const inkeep_ai_bot = {
    intro_message: 'こんにちは、Logto AI です！\n\nドキュメント、ヘルプ記事、およびその他のコンテンツで訓練された AI アシスタントです。\n\n`Logto` に関して何でも質問してください。',
    chat_placeholder: 'Logto AI に質問して、ステップバイステップのガイドを受け取る',
    disclaimer_label: 'Logto AI 免責事項',
    disclaimer_tooltip: '回答は AI によって生成され、検証が必要な場合があります。',
    example_questions_label: '質問の例',
    example_questions: [
        'Logto セットアップのクイックスタートガイド',
        'マルチテナンシーアーキテクチャの構成',
        'ユーザープロファイルを統合する方法？',
    ],
    stop: '停止',
    clear: '最初から始める',
    get_help: 'サポートを受ける',
    copy_chat: 'コピー',
    ask_ai_label: 'AI に質問',
    contact: 'お問い合わせ',
    discord: 'Discord',
};
export default Object.freeze(inkeep_ai_bot);
